import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import {
  StorageCheckDto,
  StorageInfoDto,
  StorageUpdateDto,
} from "../../../types/adminStorage";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminStorageApi {
  getStorageList(): Promise<{ storageList: StorageInfoDto[]; ver: string }>;
  getStorageStoppedList(): Promise<{
    storageList: StorageInfoDto[];
    ver: string;
  }>;
  getStorageDetail(serverKey: string): Promise<StorageInfoDto>;
  checkStorageStatus(serverKey: string): Promise<StorageCheckDto>;
  updateStorageStatus(param: StorageUpdateDto): Promise<StorageInfoDto>;
  deleteStorage(serverKey: string): Promise<StorageInfoDto>;
}

class AdminStorageServerApi implements AdminStorageApi {
  async getStorageList(): Promise<{
    storageList: StorageInfoDto[];
    ver: string;
  }> {
    const resp = await axiosAdmin.get<{
      storageList: StorageInfoDto[];
      ver: string;
    }>(`${GATEWAY_URL}/wapi/admins/storage/list`);
    return Promise.resolve(resp.data);
  }

  async getStorageStoppedList(): Promise<{
    storageList: StorageInfoDto[];
    ver: string;
  }> {
    const resp = await axiosAdmin.get<{
      storageList: StorageInfoDto[];
      ver: string;
    }>(`${GATEWAY_URL}/wapi/admins/storage/R/list`);
    return Promise.resolve(resp.data);
  }

  async getStorageDetail(serverKey: string): Promise<StorageInfoDto> {
    const resp = await axiosAdmin.get<StorageInfoDto>(
      `${GATEWAY_URL}/wapi/admins/storage/${serverKey}/detail`
    );
    return Promise.resolve(resp.data);
  }

  async checkStorageStatus(serverKey: string): Promise<StorageCheckDto> {
    const resp = await axiosAdmin.get<StorageCheckDto>(
      `${GATEWAY_URL}/wapi/admins/storage/check/${serverKey}`
    );
    return Promise.resolve(resp.data);
  }

  async updateStorageStatus(param: StorageUpdateDto): Promise<StorageInfoDto> {
    const resp = await axiosAdmin.post<StorageInfoDto>(
      `${GATEWAY_URL}/wapi/admins/storage/update/detail`,
      param
    );
    return Promise.resolve(resp.data);
  }

  async deleteStorage(serverKey: string): Promise<StorageInfoDto> {
    const resp = await axiosAdmin.get<StorageInfoDto>(
      `${GATEWAY_URL}/wapi/admins/storage/delete/${serverKey}`
    );
    return Promise.resolve(resp.data);
  }
}

const adminStorageApi: AdminStorageApi = new AdminStorageServerApi();
export default adminStorageApi;
